import { Form } from "antd";

import { ApplicationConfigurationsValidationsEdit } from "src/app/features/ApplicationConfigurations/components/validations/ApplicationConfigurationsValidationsEdit";
import { useTranslation } from "src/translations";
import type { FieldMethod, FormFieldFactoryProps } from "../../../Form/types/types";

export const EditableListAppConfigsValidationsEditField: FieldMethod = ({ field, rules }: FormFieldFactoryProps) => {
    const { t } = useTranslation();

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules} label={t(field.translationKeys.label)}>
            <ApplicationConfigurationsValidationsEdit key={field.name} />
        </Form.Item>
    );
};
